import { ref, watch } from '@nuxtjs/composition-api';
import { OSM_STATUS } from '@/constants/OsmStatus';
import useTlmCart from '~/composable/useTlmCart';
import useErrorHandler from '~/composable/useErrorHandler';

export default function useOsm (appContext) {
  const osmOrderResult = ref('');
  const osmStatusResult = ref(null);
  const hubbleClient = appContext.$hubble;
  const { getCartID } = useTlmCart(appContext);
  const { catchApiFailureWithNoAction } = useErrorHandler()

  if (!appContext || !hubbleClient) {
    throw new Error('You must provide the nuxt app context to use this composable');
  }
  const setDefaultOsmStatus = () => {
    osmStatusResult.value = OSM_STATUS.NO_RESPONSE
  }
  const validateOsm = async (customerDetails) => {
    const osmOrderId = await hubbleClient.osm.validateOsm(customerDetails, getCartID.value).catch(err => catchApiFailureWithNoAction(err))
    osmOrderResult.value = osmOrderId?.data
  };
  const getOsmStatus = async (osmOrderId) => {
    // setDefaultOsmStatus()
    const res = await hubbleClient.osm.getOsmStatus(osmOrderId, getCartID.value);
    osmStatusResult.value = res.data
  };
  watch(osmOrderResult, () => {
    if (osmOrderResult?.value?.osmOrderId !== undefined) {
      getOsmStatus(osmOrderResult.value.osmOrderId).catch(() => {
      // getOsmStatus('2424242').catch(err => { // to initiate rejected state - on Hubble mock for osm
        setDefaultOsmStatus()
      })
    } else {
      setDefaultOsmStatus()
    }
  });
  const setOsmResultInStorage = () => {
    appContext.$storage.setLocalStorage('osmStatus', osmStatusResult.value.status.statusText);
    appContext.$storage.setLocalStorage('osmOrderId', osmOrderResult.value.osmOrderId);
  }
  const getOsmResultFromStorage = () => {
    return {
      osmStatus: appContext.$storage.getLocalStorage('osmStatus'),
      osmOrderId: appContext.$storage.getLocalStorage('osmOrderId')
    }
  }
  const saveOsmDetails = () => {
    const osmDetails = getOsmResultFromStorage()
    hubbleClient.osm.saveOsmDetails(osmDetails.osmStatus, osmDetails.osmOrderId, getCartID.value).catch(err => catchApiFailureWithNoAction(err))
  }
  return {
    saveOsmDetails,
    getOsmResultFromStorage,
    setOsmResultInStorage,
    validateOsm,
    osmOrderResult,
    getOsmStatus,
    osmStatusResult
  }
}
